import React from 'react';
import Form from '../../../components/common/Form';
import {NavLink} from 'react-router-dom';

class TotalSubscribers extends Form {
    constructor(props) {
        super(props);
        this.state = {
            subscribers_count_total: this.props.subscribers_count_total,
            subscribers_count_immediate_total: this.props.subscribers_count_immediate_total,
            subscribers_count_daily_total: this.props.subscribers_count_daily_total,
            subscribers_count_weekly_total: this.props.subscribers_count_weekly_total,
            errors: {}

        };
    }

    render() {
        const {
            subscribers_count_total,
            subscribers_count_immediate_total,
            subscribers_count_daily_total,
            subscribers_count_weekly_total,
            subscription_plan,
            subscription_plan_percentage,
            subscription_plan_name,
            interval
        } = this.props;
        let used_percent_plan = Math.round(subscribers_count_total / 10);

        return (
            <div className="dash-panel m-m-b">
                {/*{console.log('subscription_plan_percentage:',subscription_plan_percentage)}*/}
                <p className="m-k-b">Total Subscribers</p>
                <div className="m-m-b">
                    <div className="text-bold subs">
                        {subscribers_count_total}
                    </div>
                    <div className="subs-info">
                        <div className="total-subs">
                            <label>Instant</label>
                            <span className="text-bold">{subscribers_count_immediate_total}</span>
                        </div>
                        <div className="total-subs" style={{marginRight: "40px"}}>
                            <label>Daily</label>
                            <span className="text-bold">{subscribers_count_daily_total}</span>
                        </div>
                        <div className="total-subs">
                            <label>Weekly</label>
                            <span className="text-bold">{subscribers_count_weekly_total}</span>
                        </div>
                    </div>
                </div>

                <div className="m-m-b">

                    <label htmlFor="">Current Plan</label>
                    <span className="text-bold">
                        {/*{console.log('current plan - subscription plan:', subscription_plan)}*/}
                        {subscription_plan_name}
                    </span>
                </div>
                <a href="https://emitto.io/pricing" target='_blank' className="text-italic">Pricing details</a>
            </div>
        )
    }
}

export default TotalSubscribers